import { cartHeaderStyles } from "@insite/content-library/Widgets/Cart/CartHeader";

cartHeaderStyles.gridItem1 = {
    width: [10, 10, 5, 7, 7],
}

cartHeaderStyles.gridItem2 = {
    width: [2, 2, 7, 5, 5],
}